import { CustomCheckboxContainer, CustomCheckboxInput } from '@reach/checkbox';
import classNames from 'classnames';
import { useCallback } from 'react';

import SvgIcon from '../../SvgIcon';

import useStyles from './styles';
import ICheckbox from './types';

import '@reach/checkbox/styles.css';

function Checkbox({
  className,
  name,
  children,
  checked,
  disabled,
  value,
  mRef,
  onCheck,
}: ICheckbox) {
  const styles = useStyles();

  const handleChange = useCallback(
    (event) => {
      onCheck(event.target.checked);
    },
    [onCheck],
  );

  return (
    <label className={classNames(styles.root, { disabled }, className)}>
      <CustomCheckboxContainer
        className={styles.checkboxContainer}
        disabled={disabled}
        checked={checked}
        onChange={handleChange}
      >
        <CustomCheckboxInput ref={mRef} name={name} value={value} className={styles.control} />

        <SvgIcon
          className={styles.icon}
          name={checked ? 'checkbox-checked-gen' : 'checkbox-unchecked-gen'}
        />

        <span className={styles.label}>{children}</span>
      </CustomCheckboxContainer>
    </label>
  );
}

export default Checkbox;
